import {
  Button,
  ButtonGroup,
  HStack,
  Popover,
  Stack,
  Text,
} from "@chakra-ui/react";
import { t } from "i18next";
import { observer } from "mobx-react";
import { useStores } from "../../../shared/stores/RootStore";
import { CustomPopover } from "../../../shared/views/CustomPopover";
import { DeleteIcon } from "../../../shared/views/icons";
import { useState } from "react";
import useAutoResizeMap from "../../../hooks/useAutoResizeMap";

const HlaSelectionHeaderBase = () => {
  const { hlaStore, streetViewStore } = useStores();
  useAutoResizeMap();

  if (hlaStore.multiSelectedIds.size === 0) {
    return null;
  }

  const nWays = hlaStore.multiSelectedIds.size;

  return (
    <HStack p={2} fontSize="sm" justifyContent="center" gap={4}>
      <Text textStyle={"label"}>
        {nWays} high-level assessment{nWays > 1 ? "s" : ""} selected
      </Text>

      <ButtonGroup size="xs" colorPalette="primary">
        <Button onClick={() => hlaStore.setMultiSelectedIds(new Set())}>
          Clear
        </Button>

        <Button
          disabled={!!hlaStore.selectedId}
          onClick={() => {
            const firstId = [...hlaStore.multiSelectedIds][0];
            hlaStore.select(firstId);

            const firstUnverified = hlaStore.get(firstId);
            if (!firstUnverified) return;
            streetViewStore.goToHla(firstUnverified);
          }}
        >
          Code
        </Button>

        <DeleteButton />
      </ButtonGroup>
    </HStack>
  );
};

export const HlaSelectionHeader = observer(HlaSelectionHeaderBase);

const DeleteButtonBase = () => {
  const { hlaStore } = useStores();
  const [deleting, setDeleting] = useState(false);

  return (
    <CustomPopover
      trigger={
        <Button colorPalette={"red"}>
          <DeleteIcon /> Delete
        </Button>
      }
    >
      <Popover.Body>
        <Stack gap={4}>
          <Text textStyle={"label"}>{`Delete ${t(`shared:ways`, {
            count: hlaStore.multiSelectedIds.size,
          })}?`}</Text>
        </Stack>
      </Popover.Body>
      <Popover.Footer justifyContent={"end"}>
        <Button
          loading={deleting}
          colorPalette={"red"}
          fontSize={"sm"}
          size="sm"
          onClick={async () => {
            setDeleting(true);

            const idsToDelete = [...hlaStore.multiSelectedIds];

            for (const id of idsToDelete) {
              await hlaStore.delete(id);
            }

            setDeleting(false);
            hlaStore.setMultiSelectedIds(new Set());
          }}
        >
          Delete
        </Button>
      </Popover.Footer>
    </CustomPopover>
  );
};

const DeleteButton = observer(DeleteButtonBase);
